import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useValidationsApi } from 'pages/hooks/useValidationsApi';

import { Page } from 'components/page/Page';

import { CandleValidationsGrid } from './components/CandleValidationsGrid';

export default () => {
  const { search } = useLocation();
  const { getData } = useValidationsApi();
  useEffect(() => {
    getData();
  }, [getData, search]);
  return (
    <Page title="Candle Validations">
      <CandleValidationsGrid />
    </Page>
  );
};
